import { WarningIcon } from '../../components/icons';
import { useAuth } from './useAuth';

/**
 * TZ §4 — a blocked or inactive account keeps full read access to its history
 * but can no longer create predictions. Saying so once, at the top of the shell,
 * is kinder than letting every bet button fail with a 403.
 */
export function BlockedAccountBanner() {
  const { isBlocked } = useAuth();
  if (!isBlocked) return null;

  return (
    <div
      role="alert"
      className="mb-4 flex items-start gap-3 rounded-card border border-negative/40 bg-negative/10 p-4"
    >
      <WarningIcon className="size-5 shrink-0 text-negative" />
      <div>
        <p className="font-semibold text-negative">Аккаунт заблокирован</p>
        <p className="mt-0.5 text-sm text-ink-muted">
          Новые прогнозы недоступны. История прогнозов, результаты и баланс по-прежнему открыты.
          Обратитесь к администратору.
        </p>
      </div>
    </div>
  );
}
